// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-control-inline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.catalogControlAnt__iconBtn.ant-btn {
  min-width: 48px;
  height: 46px;
  border-radius: 12px;
  border-color: #ccd9ec;
  background: #ffffff;
  box-shadow: 0 4px 10px rgba(16, 60, 128, 0.07);
  padding-inline: 0;
}
.catalogControlAnt__iconBtn.ant-btn .anticon {
  font-size: 18px;
}
.catalogControlAnt__iconBtn.ant-btn:hover, .catalogControlAnt__iconBtn.ant-btn:focus {
  border-color: #8bbdf5 !important;
  color: #14bdf3 !important;
  background: #ffffff !important;
}

.catalogControlAnt__popover .ant-popover-inner {
  border-radius: 16px;
  border: 1px solid #d8e5f8;
  background: #f9fbff;
  box-shadow: 0 20px 36px rgba(16, 62, 126, 0.18);
  padding: 0;
}

.catalogControlAnt__popover .ant-popover-inner-content {
  padding: 0;
}

.catalogControlAnt__popoverContent,
.catalogSortAnt__popoverContent {
  width: min(340px, 100vw - 24px);
  padding: 18px 18px 16px;
}

.catalogControlAnt__popoverTitle {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 800;
  color: #243753;
}

.catalogControlAnt__section {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.catalogControlAnt__section + .catalogControlAnt__section {
  margin-top: 14px;
}

.catalogControlAnt__sectionTitle {
  font-size: 12px;
  font-weight: 700;
  color: #6a7d99;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.catalogControlAnt__options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.catalogControlAnt__optionRow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  cursor: pointer;
}

.catalogControlAnt__optionCheckbox {
  display: inline-flex;
  align-items: center;
}
.catalogControlAnt__optionCheckbox .ant-checkbox-inner {
  width: 18px;
  height: 18px;
  border-radius: 6px;
  border-color: #c8d8ef;
}
.catalogControlAnt__optionCheckbox:hover .ant-checkbox-inner {
  border-color: #6db6ec;
}
.catalogControlAnt__optionCheckbox .ant-checkbox-checked .ant-checkbox-inner {
  background: #1bb8f2;
  border-color: #1bb8f2;
}

.catalogControlAnt__optionLabel {
  color: #2f3e57;
  font-size: 13px;
}

.catalogSortAnt__options {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.catalogSortAnt__option.ant-btn {
  width: 100%;
  justify-content: flex-start;
  border-radius: 10px;
  height: auto;
  min-height: 34px;
  font-weight: 600;
  color: #2f3e57;
  padding: 7px 9px;
}
.catalogSortAnt__option.ant-btn:hover, .catalogSortAnt__option.ant-btn:focus {
  color: #1b4a84 !important;
  background: #eef5ff !important;
}

.catalogSortAnt__option--active.ant-btn {
  color: #1b4a84 !important;
  background: #e8f2ff !important;
}

.catalogSortAnt__optionIcon {
  display: inline-flex;
  width: 16px;
  margin-right: 8px;
  justify-content: center;
}

@media screen and (max-width: 767.98px) {
  .catalogControlAnt__iconBtn.ant-btn {
    min-width: 44px;
    height: 42px;
    border-radius: 10px;
  }
  .catalogControlAnt__iconBtn.ant-btn .anticon {
    font-size: 16px;
  }
  .catalogControlAnt__popoverContent,
  .catalogSortAnt__popoverContent {
    width: min(320px, 100vw - 16px);
    padding: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/catalog/catalogControl/CatalogControl.sass"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AACF;;AACA;EACE,eAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,8CAAA;EACA,iBAAA;AAEF;AAAE;EACE,eAAA;AAEJ;AAAE;EAEE,gCAAA;EACA,yBAAA;EACA,8BAAA;AACJ;;AACA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+CAAA;EACA,UAAA;AAEF;;AAAA;EACE,UAAA;AAGF;;AADA;;EAEE,+BAAA;EACA,uBAAA;AAIF;;AAFA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAKF;;AAHA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAMF;;AAJA;EACE,gBAAA;AAOF;;AALA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AAQF;;AANA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AASF;;AAPA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AAUF;;AARA;EACE,oBAAA;EACA,mBAAA;AAWF;AATE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAWJ;AATE;EACE,qBAAA;AAWJ;AATE;EACE,mBAAA;EACA,qBAAA;AAWJ;;AATA;EACE,cAAA;EACA,eAAA;AAYF;;AAVA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAaF;;AAXA;EACE,WAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAcF;AAZE;EAEE,yBAAA;EACA,8BAAA;AAaJ;;AAXA;EACE,yBAAA;EACA,8BAAA;AAcF;;AAZA;EACE,oBAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;AAeF;;AAbA;EACE;IACE,eAAA;IACA,YAAA;IACA,mBAAA;EAgBF;EAdE;IACE,eAAA;EAgBJ;EAdA;;IAEE,+BAAA;IACA,aAAA;EAgBF;AACF","sourcesContent":[".catalog-control-inline\n  display: inline-flex\n  align-items: center\n  gap: 8px\n\n.catalogControlAnt__iconBtn.ant-btn\n  min-width: 48px\n  height: 46px\n  border-radius: 12px\n  border-color: #ccd9ec\n  background: #ffffff\n  box-shadow: 0 4px 10px rgba(16, 60, 128, 0.07)\n  padding-inline: 0\n\n  .anticon\n    font-size: 18px\n\n  &:hover,\n  &:focus\n    border-color: #8bbdf5 !important\n    color: #14bdf3 !important\n    background: #ffffff !important\n\n.catalogControlAnt__popover .ant-popover-inner\n  border-radius: 16px\n  border: 1px solid #d8e5f8\n  background: #f9fbff\n  box-shadow: 0 20px 36px rgba(16, 62, 126, 0.18)\n  padding: 0\n\n.catalogControlAnt__popover .ant-popover-inner-content\n  padding: 0\n\n.catalogControlAnt__popoverContent,\n.catalogSortAnt__popoverContent\n  width: min(340px, calc(100vw - 24px))\n  padding: 18px 18px 16px\n\n.catalogControlAnt__popoverTitle\n  margin: 0 0 12px\n  font-size: 16px\n  font-weight: 800\n  color: #243753\n\n.catalogControlAnt__section\n  display: flex\n  flex-direction: column\n  gap: 8px\n\n.catalogControlAnt__section + .catalogControlAnt__section\n  margin-top: 14px\n\n.catalogControlAnt__sectionTitle\n  font-size: 12px\n  font-weight: 700\n  color: #6a7d99\n  text-transform: uppercase\n  letter-spacing: 0.04em\n\n.catalogControlAnt__options\n  display: flex\n  flex-direction: column\n  gap: 8px\n\n.catalogControlAnt__optionRow\n  display: flex\n  align-items: center\n  gap: 8px\n  margin: 0\n  cursor: pointer\n\n.catalogControlAnt__optionCheckbox\n  display: inline-flex\n  align-items: center\n\n  .ant-checkbox-inner\n    width: 18px\n    height: 18px\n    border-radius: 6px\n    border-color: #c8d8ef\n\n  &:hover .ant-checkbox-inner\n    border-color: #6db6ec\n\n  .ant-checkbox-checked .ant-checkbox-inner\n    background: #1bb8f2\n    border-color: #1bb8f2\n\n.catalogControlAnt__optionLabel\n  color: #2f3e57\n  font-size: 13px\n\n.catalogSortAnt__options\n  display: flex\n  flex-direction: column\n  gap: 6px\n\n.catalogSortAnt__option.ant-btn\n  width: 100%\n  justify-content: flex-start\n  border-radius: 10px\n  height: auto\n  min-height: 34px\n  font-weight: 600\n  color: #2f3e57\n  padding: 7px 9px\n\n  &:hover,\n  &:focus\n    color: #1b4a84 !important\n    background: #eef5ff !important\n\n.catalogSortAnt__option--active.ant-btn\n  color: #1b4a84 !important\n  background: #e8f2ff !important\n\n.catalogSortAnt__optionIcon\n  display: inline-flex\n  width: 16px\n  margin-right: 8px\n  justify-content: center\n\n@media screen and (max-width: 767.98px)\n  .catalogControlAnt__iconBtn.ant-btn\n    min-width: 44px\n    height: 42px\n    border-radius: 10px\n\n    .anticon\n      font-size: 16px\n\n  .catalogControlAnt__popoverContent,\n  .catalogSortAnt__popoverContent\n    width: min(320px, calc(100vw - 16px))\n    padding: 14px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
